import * as React from 'react';
import { connect } from 'react-redux';
import { push } from "connected-react-router";
import { toastr } from "react-redux-toastr";
import { CallLocalRequestGet } from '../../Helpers/axiosHelpers';
import { IUserData } from '../../redux/constants';
import ManualComp from './ManualComp';
import { ArrayToTree } from './ManualComp';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { SpinnerComponent } from 'react-element-spinner';
import { withTranslation } from 'react-i18next';
import { Input, Label, FormGroup, Row, Col } from "reactstrap";
import { MiddleModal } from '../../components/ReusableComponents/Bars/BasicComponents';
import { default as Select } from 'react-select';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Zoom from '@material-ui/core/Zoom';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
declare var require: any

const queryString = require('querystring');
const EmptyGuid = '00000000-0000-0000-0000-000000000000';

const $ = require("jquery");
interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children: React.ReactElement;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'fixed',
            bottom: theme.spacing(2),
            right: theme.spacing(4),
        },
    }),
);
function ScrollTop(props: Props) {
    const { children, window } = props;
    const classes = useStyles();
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const anchor = ((event.target as HTMLDivElement).ownerDocument || document).querySelector(
            '#back-to-top-anchor',
        );

        if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    return (
        <Zoom in={trigger} style={{ visibility: "unset", transform: "unset" }}>
            <div onClick={handleClick} className={classes.root} id="triggerClick" >
                {children}
            </div>
        </Zoom>
    );
}
interface ManualProps {
    push: any;
    theme: any;
    UserData: IUserData;
    APIUrl: string;
    location: any;
    Expanded: string[];
    language: any;
    t: any;
}
interface ManualStates {
    openContact: boolean;
    nodes: any;
    ArticleID: string;
    ManualId: any;
    isLoading: boolean;
    MenuItemsAdmin: any[];
    MenuItemsClient: any[];
    Article: any;
    Paragraphs: Paragraph[];
    idsArray: any[];
    Expanded: any[];

}
const mapStateToProps = (state: any) => ({
    UserData: state.auth.UserData,
    GlobalUser: state.auth.GlobalUser,
    lang: state.language.value,
    state: state.sidebar,
    layout: state.layout,
    history: state.history,
    theme: state.theme,
    location: state.router.location,
    APIUrl: state.auth.APIUrl,
    language: state.language,
});
class Paragraph {
    Id: string = "";
    Title: string = "";
    Content: string = "";
    Order: number = 0;
    Key: number = 0;
    rteObj: any;
}
//class ManualClass {
//    MenuItems: any = [] as any;//any[]
//    Paragraphs: Paragraph[] = [];
//}
//class MenuItem {
//    Id: string = '';
//    Title: string = '';
//    ParentId: string = '';
//    Order: number = 0;
//    IsArticle: boolean = false;
//}
export class ManualList {
    id: string = "";
    text: string = "";
    parentId: string = "";
}
const dispatchProps = { push };
class Manual extends React.Component<ManualProps, ManualStates> {
    state = {
        nodes: null,
        ArticleID: '',
        ManualId: this.props.UserData.isAdmin ? '278B8FAB-4AEE-42EE-94B3-A214B13FA673' : '28E19F04-0116-43E2-B3B6-329E33690AA2',
        Topics: [],
        MenuItemsAdmin: [] as any,
        MenuItemsClient: [] as any,
        Article: { Title: '' },
        Paragraphs: [],
        idsArray: [],
        Expanded: [],
        isLoading: false,
        openContact: false
    };

    componentDidMount() {
        let values = queryString.parse(this.props.location.search);
        let ArticleID = values['Article'];
        let ManualId = values['?Manual'];
        if (ManualId !== EmptyGuid) {
            this.setState({
                ManualId,
                ArticleID
            }, this.LoadManual);
        } else {
            this.setState({ ArticleID }, this.LoadManual);
        }
    }
    LoadManual = () => {
        let adminManualUrl = this.props.UserData.CDNURL + "manual/data/278b8fab-4aee-42ee-94b3-a214b13fa673/" + this.props.language.value + ".json?v=" + new Date().getTime();
        CallLocalRequestGet<any, any>(adminManualUrl,
            {}, (res: any) => {
                this.setState({
                    MenuItemsAdmin: ArrayToTree(res.data)
                }, this.LoadFirstItem);
            }, () => {
                this.setState({ isLoading: false });
                toastr.error('', this.props.t('ErrorContactingServer'));
            });
        let clientManualUrl = this.props.UserData.CDNURL + "manual/data/28e19f04-0116-43e2-b3b6-329e33690aa2/" + this.props.language.value + ".json?v=" + new Date().getTime();
        CallLocalRequestGet<any, any>(clientManualUrl,
            {}, (res: any) => {
                this.setState({
                    MenuItemsClient: ArrayToTree(res.data)
                });
            }, () => {
                this.setState({ isLoading: false });
                toastr.error('', this.props.t('ErrorContactingServer'));
            });
    }
    LoadFirstItem = () => {
        try {
            if (this.state.MenuItemsAdmin
                && this.state.MenuItemsAdmin[0]
                && this.state.MenuItemsAdmin[0].items
                && this.state.MenuItemsAdmin[0].items[0]
                && this.state.MenuItemsAdmin[0].items[0].id
            )
                this.LoadParagraph(this.state.MenuItemsAdmin[0].items[0].id, this.state.MenuItemsAdmin[0].items[0].Version ? this.state.MenuItemsAdmin[0].items[0].Version : this.state.MenuItemsAdmin[0].items[0].Version, this.state.MenuItemsAdmin[0].items[0].ManualId)
            $('.dx-treeview-node[data-item-id=' + this.state.MenuItemsAdmin[0].items[0].id + ']').addClass('dx-state-selected');
        } catch (er) { }
    }
    LoadParagraph = (ArticleID: any, Version: number, ManualId: string) => {
        const json = this.props.UserData.CDNURL + "manual/data/" + ManualId + '/' + ArticleID + ".json?v=" + Version
        CallLocalRequestGet<any, any>(json,
            {}, (res: any) => {
                this.setState({
                    Paragraphs: res.data.Paragraphs
                }, this.triggerButton);
                var options = [];
                for (let k = 0; k < this.state.Paragraphs.length; k++) {
                    options.push({ label: 'section' + k })
                }
                var finalArray = options.map(function (obj: any) {
                    return obj.label;
                })
                this.setState({ idsArray: finalArray })
            }, () => {
                this.setState({ isLoading: false });
                toastr.error('', this.props.t('ErrorContactingServer'));
            });

    }
    triggerButton = () => {
        $(document).ready(function () {
            $('#triggerClick button').trigger('click');
        })
    }
    clickItem = (e: any) => {
        if (e.itemData.IsArticle) {
            this.LoadParagraph(e.itemData.id, e.itemData.Version, e.itemData.ManualId);
            this.triggerButton();
        }
        else {
            $('.dx-treeview-node[data-item-id=' + e.itemData.id + ']').addClass('notClickable');
        }
        this.triggerButton();
    }
    openContact = () => {
        this.setState({ openContact: true })
    }
    closeContact = () => {
        this.setState({ openContact: false })
    }
    addContact = () => {

    }
    inputOnchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value } as any)
    }
    render() {
        return (
            <div>
                <SpinnerComponent loading={this.state.isLoading} position="inline" color="#00ad0f" />
                <div className={this.state.isLoading ? "blurBackground " : ""}>
                    <MiddleModal
                        openModal={this.state.openContact}
                        titleText={this.props.t('NewContact')}
                        showClose={false}
                        body={
                            <div>
                                <Row>
                                    <Col col-md={6}>
                                        <FormGroup >
                                            <Label for="FirstName" className="LabelCreate2 d-contents  font-14" > {this.props.t('FirstName')}: </Label>
                                            <Input
                                                type="text"
                                                name="FirstName"
                                                bsSize="lg"
                                                className="Inputs"
                                                onChange={this.inputOnchange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col col-md={6}>
                                        <FormGroup >
                                            <Label for="LastName" className="LabelCreate2 d-contents  font-14" > {this.props.t('LastName')}: </Label>
                                            <Input
                                                type="text"
                                                name="LastName"
                                                bsSize="lg"
                                                className="Inputs"
                                                onChange={this.inputOnchange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col col-md={12}>
                                        <FormGroup >
                                            <Label for="ContactDisplayName" className="LabelCreate2 d-contents  font-14" > {this.props.t('ContactDisplayName')}: </Label>
                                            <Input
                                                type="text"
                                                name="ContactDisplayName"
                                                bsSize="lg"
                                                className="Inputs"
                                                onChange={this.inputOnchange}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col col-md={12}>
                                        <FormGroup >
                                            <Label for="Email" className="LabelCreate2 d-contents  font-14" > {this.props.t('Email')}: </Label>
                                            <Input
                                                type="text"
                                                name="Email"
                                                bsSize="lg"
                                                className="Inputs"
                                                onChange={this.inputOnchange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="Country" className="LabelCreate2 d-contents" >  {this.props.t('Country')}: </Label>
                                            <Select
                                                className="react-select-container LargeSelect"
                                                classNamePrefix="react-select cursor-pointer LargeSelect DarkSelect "
                                                isSearchable
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col col-md={12}>
                                        <FormGroup >
                                            <Label for="Phone" className="LabelCreate2 d-contents  font-14" > {this.props.t('Phone')}: </Label>
                                            <Input
                                                type="text"
                                                name="Phone"
                                                bsSize="lg"
                                                className="Inputs"
                                                onChange={this.inputOnchange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        }
                        closeModal={this.closeContact}
                        ActionClick={this.addContact}
                        ButtonText={this.props.t('Add')}
                    />
                    <ManualComp
                        data={[...this.state.MenuItemsAdmin, ...this.state.MenuItemsClient]}
                        clickItem={this.clickItem}
                        Paragraphs={this.state.Paragraphs}
                        MainTitle={this.props.t('Documentation')}
                        SubTitle={this.props.t('AssistMessage')}
                        tableTitle={this.props.t('InThisArticle')}
                        filterInput={this.props.t('FilterByTitle')}
                        idsArray={this.state.idsArray} />
                    <ScrollTop>
                        <Fab color="secondary" size="small" aria-label="scroll back to top" id="triggerClick" >
                            <KeyboardArrowUpIcon />
                        </Fab>
                    </ScrollTop>
                </div>
            </div>
        )
    }
}
export default withTranslation()(connect(mapStateToProps, dispatchProps)(Manual));

